import { defineMessages } from 'react-intl';

export default defineMessages({
    removeDocument: {
        id: 'policy.component.documents.Remove Document',
        defaultMessage: 'Remove Document',
    },
    confirmRemoveDocument: {
        id: 'policy.component.documents.Are you sure you want to remove',
        defaultMessage: 'Are you sure you want to remove',
    },
    documentRemoveConfirmYes: {
        id: 'policy.component.documents.Yes',
        defaultMessage: 'Yes',
    },
    documentRemoveConfirmNo: {
        id: 'policy.component.documents.No',
        defaultMessage: 'No',
    },
    documentDeletionFailed: {
        id: 'policy.component.documents.Document deletion failed',
        defaultMessage: 'Document deletion failed',
    },
    documentCannotDeleted: {
        id: 'policy.component.documents.Sorry your document could not be deleted at this time',
        defaultMessage: 'Sorry your document could not be deleted at this time',
    },
    documentDateUploaded: {
        id: 'policy.component.documents.Date Uploaded',
        defaultMessage: 'Date Uploaded',
    },
    documentUploadFailed: {
        id: 'policy.component.documents.Document upload failed',
        defaultMessage: 'Document upload failed',
    },
    documentCannotUploaded: {
        id: 'policy.component.documents.Failed to upload file, either you do not have permission or a file exists with the same name.',
        defaultMessage:
            'Failed to upload file, either you do not have permission or a file exists with the same name.',
    },
    noDocumentFound: {
        id: 'policy.component.documents.No Documents Found.',
        defaultMessage: 'No Documents Found.',
    },
    uploadedDocuments: {
        id: 'policy.component.documents.Upload Documents',
        defaultMessage: 'Uploaded Documents',
    },
    policyDocuments: {
        id: 'policy.component.documents.Policy Document',
        defaultMessage: 'Policy Documents',
    },
});
